'use client';

import { useId } from 'react';

function useRandomClassName() {
  var id = useId().replace(/:/g, "");
  return "__m__-".concat(id);
}

export { useRandomClassName };